import styles from "./Answer.module.scss";
import { useEffect, useRef } from "react";

type Props = {
  id: string;
  label: string;
  applyFocus?: boolean;
  onSelect: () => void;
};
const Answer = ({ id, label, onSelect, applyFocus }: Props) => {
  const buttonRef = useRef<null | HTMLLabelElement>(null);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const handleKeyDown = (e) => {
    if ([13, 32].includes(e.keyCode)) {
      e.target.click();
    }
  };

  useEffect(() => {
    if (applyFocus) buttonRef.current?.focus();
  }, [applyFocus, buttonRef]);

  return (
    <div className={styles.answer}>
      <input
        className={styles.answer__input}
        type="radio"
        name={`grading${id}`}
        id={`grading${id}${label}`}
        tabIndex={-1}
      />
      <label
        className={styles.answer__button}
        htmlFor={`grading${id}${label}`}
        onClick={onSelect}
        tabIndex={0}
        onKeyDown={handleKeyDown}
        ref={buttonRef}
      >
        {label}
      </label>
    </div>
  );
};

export default Answer;
